( function (global) {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelector('.js-btn-go-to-main').addEventListener('click', onBtnGoToMainClick);
        document.querySelector('.js-btn-menu-show').addEventListener('click', onBtnMenuShowClick, false);

        global.GAEvent.init(document.querySelector('.js-btn-go-to-section--open'));

        let linksActionsItems = document.querySelectorAll('.page-links-actions__item');
        [].forEach.call(linksActionsItems, (item) => {
            global.GAEvent.init(item);
        });

        let attachmentsFilesLinks = document.querySelectorAll('.js-attachment-file-link');
        [].forEach.call(attachmentsFilesLinks, (item) => {
            global.GAEvent.init(item);
        });

    });

    function isOpenMainMenu() {
        return document.querySelector('.main-nav').classList.contains('main-nav--show');
    }

    function onBtnMenuShowClick(evt) {
        let element = evt.currentTarget;
        setTimeout(() => {
            if (!isOpenMainMenu()) {
                return;
            }

            global.GAEvent.sendByElement(element);
        }, 500);

    }

    function onBtnGoToMainClick(evt) {
        let href = evt.currentTarget.href;
        if (!href) {
            return;
        }

        evt.preventDefault();

        function fnGo() {
            if (href) {
                document.location.href = href;
            }
        }

        setTimeout(fnGo, 500);

        global.GAEvent.sendByElement(evt.currentTarget, fnGo, 100);
    }

}(window));

